import {action, Action} from 'easy-peasy';

interface EventFilter {
    id: number;
    name: string;
}

interface EventFiltersState {
    items: EventFilter[];
    loadEventFilters: Action<EventFiltersState, EventFilter[]>;
}

const eventFilters: EventFiltersState = {
    items: [],
    loadEventFilters: action((state, eventFiltersList) => {
        state.items = eventFiltersList;
    }),
};

export default eventFilters; 